var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 522,
    viewBox: "0 0 512 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.0558 197.375C113.346 197.375 128.984 181.736 128.984 162.443C128.984 143.151 113.346 127.512 94.0558 127.512C74.7653 127.512 59.1274 143.151 59.1274 162.443C59.1274 181.736 74.7653 197.375 94.0558 197.375ZM94.0558 197.375V237.279C94.0558 242.25 98.0852 246.279 103.056 246.279H149.941M149.941 246.279V185.416C149.941 180.445 153.971 176.416 158.941 176.416H226.784M149.941 246.279V321.383M226.784 176.416V85.5938C226.784 -17.4542 424.129 -26.1863 424.129 85.5938V176.416M226.784 176.416H424.129M424.129 176.416H478C482.971 176.416 487 180.445 487 185.416V452.109C487 457.079 482.971 461.109 478 461.109H158.941C153.971 461.109 149.941 457.079 149.941 452.109V391.246M149.941 321.383H94.0558M149.941 321.383V391.246M94.0558 321.383C94.0558 366.794 26 368.541 26 321.383C26 270.732 94.0558 270.732 94.0558 321.383ZM149.941 391.246H103.056C98.0852 391.246 94.0558 395.275 94.0558 400.246V443.644M94.0558 443.644C146.394 443.644 143.01 517 94.0558 517C41.7178 517 41.7178 443.644 94.0558 443.644ZM305.427 326.623V391.246C305.427 410.207 349.087 410.207 349.087 391.246V326.623C382.269 326.623 396.437 234.054 326.384 234.054C258.274 234.054 265.259 326.623 305.427 326.623Z",
    stroke: "#4487C5",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessControl);
export default __webpack_public_path__ + "static/media/access-control.95d4e4b98e6c51cb6c09d69eb60b589d.svg";
export { ForwardRef as ReactComponent };